import { makeRequest, TD_API_URL } from '@eventbrite/toneden-api';
import {
    BoostTrial,
    StartBoostTrialError,
    StartBoostTrialParams,
} from '../types';

export const getBoostTrial = () => {
    return new Promise<BoostTrial>((resolve, reject) => {
        makeRequest(
            'get',
            `${TD_API_URL}boost/users/me/trials/`,
            {},
            (error: Error, body: BoostTrial) => {
                if (error) {
                    console.log('Error fetching Boost trial info:', error);

                    reject(error);
                }

                resolve(body);
            },
        );
    });
};

export const startBoostTrial = (trialVersion: string) => {
    const params: StartBoostTrialParams = {};

    if (trialVersion) {
        params.trial_version = trialVersion;
    }

    return new Promise((resolve, reject) => {
        makeRequest(
            'post',
            `${TD_API_URL}boost/users/me/trials/`,
            params,
            (error: StartBoostTrialError) => {
                if (!error) {
                    return resolve(true);
                }

                console.log('Error creating Boost trial:', error);
                reject(error);
            },
        );
    });
};
